<template>
    <div class="em-breve">
        <img src="@/assets/images/error/empty.svg" />
        <h4>Nenhuma página encontrada</h4>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.em-breve {
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 10rem 0;
    justify-content: center;
    align-items: center;
}

.em-breve img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
</style>